"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.styles = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronRight"));

var _ChevronLeft = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronLeft"));

var _withStyles = _interopRequireDefault(require("../../styles/withStyles"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _tokens = require("../../styles/tokens");

var _EDSContext = require("../../EDSContext/EDSContext");

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _excluded = ["classes", "className", "direction", "edsContext", "onClick", "visible", "hideScrollButtons"];
var styles = {
  /* Styles applied to the root element. */
  root: {
    color: 'inherit',
    flexBasis: 'auto',
    alignSelf: 'center',
    margin: '0 0.125rem'
  },
  icon: {
    height: _tokens.spacing40,
    width: _tokens.spacing40
  },
  scrollLeftIcon: {
    marginRight: _tokens.spacing30
  },
  scrollRightIcon: {
    marginLeft: _tokens.spacing30
  },
  hideScrollButtons: {
    display: 'none'
  }
};
exports.styles = styles;

var TabScrollButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames, _classNames2;

  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      edsContext = props.edsContext,
      onClick = props.onClick,
      visible = props.visible,
      hideScrollButtons = props.hideScrollButtons,
      other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var className = (0, _classnames.default)('tab-scroll-button', classes.root, (_classNames = {}, _classNames[classes.hideScrollButtons] = hideScrollButtons, _classNames), classNameProp, (_classNames2 = {}, _classNames2[classes.scrollLeftIcon] = direction === 'left', _classNames2[classes.scrollRightIcon] = direction === 'right', _classNames2));
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: edsContext.formatMessage('component.Tabs.scrollButtons'),
    enterDelay: 1000,
    enterNextDelay: 1000
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    "aria-label": edsContext.formatMessage('component.Tabs.scrollButtons'),
    className: className,
    onClick: onClick,
    tabIndex: -1,
    color: "gray",
    disabled: !visible
  }, other, {
    ref: ref
  }), direction === 'left' ? /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
    className: classes.icon
  }) : /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    className: classes.icon
  })));
});

TabScrollButton.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The direction of icon to render.
   */
  direction: _propTypes.default.oneOf(['left', 'right']),

  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,

  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool,

  /**
   * For auto mode, buttons will be hidden if tabs don't need scrolling
   */
  hideScrollButtons: _propTypes.default.bool
};
TabScrollButton.defaultProps = {
  visible: true
};
TabScrollButton.muiName = 'MuiPrivateTabScrollButton';

var _default = (0, _EDSContext.withEDSContext)((0, _withStyles.default)(styles)(TabScrollButton));

exports.default = _default;